"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBrandedLogo = void 0;
var styled_components_1 = require("styled-components");
var agco_1 = __importDefault(require("./brands/agco"));
var massey_1 = __importDefault(require("./brands/massey"));
var valtra_1 = __importDefault(require("./brands/valtra"));
var fendt_1 = __importDefault(require("./brands/fendt"));
var useBrandedLogo = function (brand) {
    var name = (0, styled_components_1.useTheme)().name;
    switch (brand !== null && brand !== void 0 ? brand : name) {
        case 'massey':
            return massey_1.default;
        case 'valtra':
            return valtra_1.default;
        case 'fendt':
            return fendt_1.default;
        case 'agco':
        default:
            return agco_1.default;
    }
};
exports.useBrandedLogo = useBrandedLogo;
